<template>
  <div ref="wrapper" class="manifest-animation">
    <div ref="heart" class="manifest-animation__item manifest-animation__item--heart">
      <img src="/svg/heart.svg" alt="">
    </div>
    <div ref="and" class="manifest-animation__item manifest-animation__item--and">
      <img src="/svg/and.svg" alt="">
    </div>
  </div>
</template>

<script>
export default {
  mounted () {
    const { wrapper, heart, and } = this.$refs
    const controller = new ScrollMagic.Controller()
    const scene = new ScrollMagic.Scene({
      triggerElement: wrapper,
      triggerHook: 'onEnter',
      duration: () => `${ (wrapper.offsetHeight / window.innerHeight) * 100 + 100 }%`
    })

    const tween = new TimelineMax()
    tween
      .to(heart, 1, { left: '100%', ease: Power0.easeNone }, 0)
      .to(and, 1, { right: '100%', ease: Power0.easeNone }, 0)

    scene
      .setTween(tween)
      .addTo(controller)
  }
}
</script>

<style lang="scss" scoped>
.manifest-animation {
  position: relative;
  filter: invert(100%);
  height: 60vh;

  @include media-up(md) {
    height: 75vh;
    max-height: 480px;
  }

  @include media-up(lg) {
    max-height: 768px;
  }

  &__item {
    position: absolute;
    top: 0;
    height: 100%;

    img {
      display: block;
      height: 100%;
      width: auto;
    }

    &--heart {
      left: 0;
      transform: translate3d(-50%, 0, 0);
      will-change: left;
    }

    &--and {
      transform: translate3d(50%, 0, 0);
      right: 0;
      mix-blend-mode: difference;
      will-change: right;
    }
  }

  @each $breakpoint-name, $space in $grid-space-around {
    @include media-up($breakpoint-name) {
      margin-right: -$space;
      margin-left: -$space;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ManifestAnimation.vue